<template>
  <div style="background: #ffffff; padding:20px; border-radius: 8px;  box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
    <div style="font-size: 18px;font-weight: 700;color: #000000;">入住寵物</div>
    <!-- 外匡線 -->
    <div
      v-for="(pet, index) in info"
      :key="index"
      style="
    font-size:16px; padding: 4px 16px;
    border: 2px solid #E5E7EB; border-radius: 8px;
    margin-top: 24px; background: #ffffff;"
    >
      <el-row style="display:flex;align-items: center; padding: 16px 4px; border-bottom: solid 1px #E5E7EB;">
        <el-col :span="5">
          <span style="font-weight:900; color:#000000">{{ pet.name }}</span>
        </el-col>
        <el-col :span="12">
          <span style="font-weight:900; color:#000000; font-size: 14px;">
            {{ formatPetMeta(pet) }}
          </span>
        </el-col>
        <el-col :span="5">
          <div style="display: flex; align-items: center;">
            <div
              style="width:12px; height: 12px; border-radius: 50%; margin-right: 8px;"
              :style="{
                backgroundColor: pet.isEvaluationRequired ? '#F74747' : '#5FC956',
              }"
            />
            <span :style="{ color: pet.isEvaluationRequired ? '#F74747' : '#5FC956' }">
              {{ pet.isEvaluationRequired ? '需評估' : '不需評估' }}
            </span>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin-top: 6px;">
        <el-col v-for="tab in availableTabs" :key="tab.value" :span="tabSpan">
          <el-button type="text" style="width: 100%;" @click="onClickTab(pet, tab)">
            <i :class="tab.icon" style="margin-right: 4px;color: #EA6A2A; font-size:18px;font-weight: 800;" />
            {{ tab.name }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckInPetListPartial',
  components: {},
  props: {
    info: {
      type: Array,
      required: true,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'view', // 'create' or 'view'
    },
  },
  // watch: {
  //   info: {
  //     immediate: true,
  //     handler(val) {
  //       console.log('[check-in-pet-list] props.info', val)
  //     },
  //   },
  // },
  data() {
    return {
      tabs: [
        {
          name: '寵物資訊',
          value: 'information',
          icon: 'el-icon-view',
        },
        {
          name: '歷史紀錄',
          value: 'service',
          icon: 'el-icon-document',
        },
        {
          name: '服務紀錄',
          value: 'currentService',
          icon: 'el-icon-document-copy',
        },
      ],
    }
  },
  computed: {
    // 根據mode過濾顯示tabs
    availableTabs() {
      // 建立訂單模式不顯示「服務紀錄」
      if (this.mode === 'create') {
        return this.tabs.filter((tab) => tab.value !== 'currentService')
      }
      return this.tabs
    },
    // 根據tabs數量計算span值
    tabSpan() {
      const count = this.availableTabs.length
      return Math.floor(24 / count)
    },
  },
  methods: {
    getCategoryTags(pet) {
      const category = pet && pet.category ? pet.category : null
      const tags = category && Array.isArray(category.tags) ? category.tags : pet && Array.isArray(pet.categoryTags) ? pet.categoryTags : []
      const title = category && category.title ? category.title : ''
      const parts = []
      if (title) parts.push(title)
      if (tags.length) parts.push(...tags)
      return parts.length ? parts.join(' | ') : ''
    },
    formatPetMeta(pet) {
      const categoryText = this.getCategoryTags(pet)
      const size = pet && pet.size ? pet.size : ''
      const weight = pet && pet.weight ? pet.weight : ''
      const sizeWeight = `${size}${weight}`.trim()
      if (categoryText && sizeWeight) return `${categoryText} | ${sizeWeight}`
      return categoryText || sizeWeight || '-'
    },
    onClickTab(pet, tab) {
      this.$emit('pet-tab-click', { pet, tab: tab.value })
    },
  },
}
</script>

<style lang="scss" scoped></style>
